<template>
  <img v-if="img" class="icon" :src="img" />
  <span
    v-else-if="html"
    :class="'icon icon-' + cls"
    v-html="html"
    :style="{ background: bg }"
  ></span>
</template>

<script>
import { theme } from '../themes.js'
export default {
  props: {
    d: null,
    name: null,
    fill: null,
    bg: null
  },
  computed: {
    cls() {
      if (this.name.indexOf('viewBox="-4 -5 24 24"') > -1) {
        return 'mdi'
      }
      if (this.name.indexOf('<svg') > -1) {
        return 'custom'
      }
      return 'mdi'
    },
    img() {
      switch (this.name) {
        case 'dreambuddy':
          return theme.avatar || '/assets/img/mascotte-cadeau.svg'
      }
    },
    html() {
      const fill = this.fill ? 'fill="' + this.fill + '"' : ''
      if (this.name.indexOf('<svg') > -1) {
        return this.name.replace('<svg', '<svg class="icon-svg"' + fill)
      }
      const d = this.paths(this.name)
      return `<svg class="icon-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path class="fill-fg" ${fill} d="${d}"></svg>`
    }
  },
  methods: {
    paths(name) {
      if (name && name.slice(0, 4) === 'mdi:') {
        return name.slice(4)
      }

      switch (name) {
        case 'arrow-left-bold':
          return 'M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z'
        case 'arrow-right-bold':
          return 'M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z'
        case 'chevron-left':
          return 'M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z'
        case 'chevron-right':
          return 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z'
        case 'auto-fix':
          return 'M7.5,5.6L5,7L6.4,4.5L5,2L7.5,3.4L10,2L8.6,4.5L10,7L7.5,5.6M19.5,15.4L22,14L20.6,16.5L22,19L19.5,17.6L17,19L18.4,16.5L17,14L19.5,15.4M22,2L20.6,4.5L22,7L19.5,5.6L17,7L18.4,4.5L17,2L19.5,3.4L22,2M13.34,12.78L15.78,10.34L13.66,8.22L11.22,10.66L13.34,12.78M14.37,7.29L16.71,9.63C17.1,10 17.1,10.65 16.71,11.04L5.04,22.71C4.65,23.1 4,23.1 3.63,22.71L1.29,20.37C0.9,20 0.9,19.35 1.29,18.96L12.96,7.29C13.35,6.9 14,6.9 14.37,7.29Z'
        case 'close':
          return 'M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z'
        case 'euro':
          return 'M7.07,11L7,12L7.07,13H17.35L16.5,15H7.67C8.8,17.36 11.21,19 14,19C16.23,19 18.22,17.96 19.5,16.33V19.12C18,20.3 16.07,21 14,21C10.08,21 6.75,18.5 5.5,15H2L3,13H5.05L5,12L5.05,11H2L3,9H5.5C6.75,5.5 10.08,3 14,3C16.5,3 18.8,4.04 20.43,5.71L19.57,7.75C18.29,6.08 16.27,5 14,5C11.21,5 8.8,6.64 7.67,9H19.04L18.19,11H7.07Z'
        case 'fire':
          return 'M11.71,19C9.93,19 8.5,17.59 8.5,15.86C8.5,14.24 9.53,13.1 11.3,12.74C13.07,12.38 14.9,11.53 15.92,10.16C16.31,11.45 16.5,12.81 16.5,14.2C16.5,16.84 14.36,19 11.71,19M13.5,0.67C13.5,0.67 14.24,3.32 14.24,5.47C14.24,7.53 12.89,9.2 10.83,9.2C8.76,9.2 7.2,7.53 7.2,5.47L7.23,5.1C5.21,7.5 4,10.61 4,14A8,8 0 0,0 12,22A8,8 0 0,0 20,14C20,8.6 17.41,3.8 13.5,0.67Z'
        case 'gender-female':
          return 'M12,4A6,6 0 0,1 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10A6,6 0 0,1 12,4M12,6A4,4 0 0,0 8,10A4,4 0 0,0 12,14A4,4 0 0,0 16,10A4,4 0 0,0 12,6Z'
        case 'gender-male':
          return 'M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15A6,6 0 0,1 9,21A6,6 0 0,1 3,15A6,6 0 0,1 9,9M9,11A4,4 0 0,0 5,15A4,4 0 0,0 9,19A4,4 0 0,0 13,15A4,4 0 0,0 9,11Z'
        case 'menu':
          return 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z'
        case 'pencil':
          return 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z'
        case 'plus':
          return 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z'
        case 'thumb-up':
          return 'M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z'
        case 'add-to-cart':
          return 'M19.3 12.7L21 5.3c.1-.5-.3-1-.9-1H5.8l-.3-1.6C5.4 2.3 5 2 4.6 2H1c-.5 0-.9.4-.9.8v.6c0 .5.4.9.9.9h2.5L6 16.4c-.6.4-1 1-1 1.7 0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-.5-.2-1-.6-1.4h7.7a2 2 0 0 0-.6 1.4c0 1.1.9 2 2 2a2 2 0 0 0 2-2 2 2 0 0 0-1.1-1.7l.2-1c.1-.4-.3-1-.9-1H8l-.3-1h10.7c.4 0 .8-.4.9-.7z'
        case 'plus':
          return 'M15 7.1H9V1.3c0-.4-.2-.7-.6-.7H7.1c-.3 0-.6.3-.6.7V7H.6c-.3 0-.6.3-.6.7V9c0 .3.3.6.6.6h5.9v5.9c0 .3.3.6.6.6h1.3c.4 0 .7-.3.7-.6V9.7h5.8c.4 0 .7-.3.7-.6V7.8c0-.4-.3-.7-.7-.7z'
        case 'share':
          return 'M19.4 9.9c-1.4 0-2.7-.7-3.6-1.8l-7 4a4.8 4.8 0 0 1 0 3l7 4a4.5 4.5 0 0 1 3.6-1.8c2.5 0 4.6 2 4.6 4.6 0 2.6-2 4.7-4.6 4.7a4.6 4.6 0 0 1-4.3-6.2l-7-4a4.5 4.5 0 0 1-3.5 1.8c-2.6 0-4.6-2-4.6-4.6C0 11 2 8.9 4.6 8.9c1.4 0 2.7.8 3.6 1.9l7-4A4.6 4.6 0 0 1 19.5.6c2.5 0 4.5 2 4.5 4.6 0 2.6-2 4.7-4.6 4.7z'
        // case 'arrow-right': return svgPath('M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z')
        // case 'backspace': return svgPath('M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12')
        // case 'chevron-down': return svgPath('M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z')
        // case 'chevron-right': return svgPath('M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z')
        // case 'copy': return svgPath('M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z')
        // case 'dots-horizontal': return svgPath('M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z')
        // case 'messenger-send': return '<svg class="icon-svg icon-messenger-send" viewBox="0 0 20 21"><path class="fill-fg" fill-rule="evenodd" d="M1.8.4L19 9c1.3.6 1.3 2.3 0 3L2 20.5c-.8.4-1.8-.2-1.8-1L.7 13c0-.5.6-1 1.2-1l9-1c.5 0 .5-1 0-1.2l-9-1C1 9 .5 8.4.4 8L0 1.5C0 .5 1 0 1.8.5"/></svg>'
        // case 'share': return svgPath('M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z"')
        // case 'spinner': return '<svg class="icon-svg icon-spinner spinning" viewBox="2 2 20 20"><path class="fill-fg" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></svg>'
        // case 'twitter': return svgPath('M23.95 4.57a10 10 0 0 1-2.82.77 4.96 4.96 0 0 0 2.16-2.72c-.95.56-2 .96-3.12 1.19a4.92 4.92 0 0 0-8.38 4.48A13.93 13.93 0 0 1 1.63 3.16a4.92 4.92 0 0 0 1.52 6.57 4.9 4.9 0 0 1-2.23-.61v.06c0 2.38 1.7 4.37 3.95 4.82a5 5 0 0 1-2.21.09 4.94 4.94 0 0 0 4.6 3.42A9.87 9.87 0 0 1 0 19.54a14 14 0 0 0 7.56 2.21c9.05 0 14-7.5 14-13.98 0-.21 0-.42-.02-.63A9.94 9.94 0 0 0 24 4.59l-.05-.02z')
        // case 'whatsapp': return svgPath('M17.5 14.38a40.8 40.8 0 0 0-2.04-.96c-.27-.1-.47-.15-.67.15-.2.3-.78.96-.95 1.16-.17.2-.35.2-.64.07-.3-.15-1.27-.46-2.4-1.48a9.07 9.07 0 0 1-1.67-2.07c-.17-.3-.02-.47.13-.62.14-.13.3-.34.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.62-.93-2.2-.24-.59-.48-.52-.67-.52l-.57-.01c-.2 0-.52.07-.8.36-.27.3-1.04 1.02-1.04 2.47s1.07 2.87 1.22 3.08c.15.2 2.1 3.2 5.1 4.48.71.3 1.27.48 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.77-.72 2.02-1.42s.25-1.3.18-1.43c-.08-.13-.27-.2-.57-.34m-5.45 7.44h-.02A10 10 0 0 1 7 20.37l-.36-.21-3.75.97 1-3.64-.23-.38a9.87 9.87 0 0 1 8.42-15.14 9.87 9.87 0 0 1 7.02 2.9 9.79 9.79 0 0 1 2.91 7 9.93 9.93 0 0 1-9.93 9.88m8.45-18.3A12.14 12.14 0 0 0 12.05 0 11.94 11.94 0 0 0 .1 11.9c0 2.09.55 4.13 1.6 5.94L0 24l6.33-1.65c1.75.94 3.71 1.44 5.71 1.44h.01A11.92 11.92 0 0 0 24 11.9a11.8 11.8 0 0 0-3.5-8.4')
      }
      return 'M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A1,1 0 0,1 1,11V8A2,2 0 0,1 3,6H6.17C6.06,5.69 6,5.35 6,5A3,3 0 0,1 9,2C10,2 10.88,2.5 11.43,3.24V3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2A3,3 0 0,1 18,5C18,5.35 17.94,5.69 17.83,6H21A2,2 0 0,1 23,8V11A1,1 0 0,1 22,12M4,20H11V12H4V20M20,20V12H13V20H20M9,4A1,1 0 0,0 8,5A1,1 0 0,0 9,6A1,1 0 0,0 10,5A1,1 0 0,0 9,4M15,4A1,1 0 0,0 14,5A1,1 0 0,0 15,6A1,1 0 0,0 16,5A1,1 0 0,0 15,4M3,8V10H11V8H3M13,8V10H21V8H13Z'
    }
  }
}
</script>

<style>
.icon {
  display: block;
  width: 1em;
  height: 1em;
  margin: auto;
}
.icon-custom {
  display: inline-flex;
  align-self: center;
  justify-content: center;
  vertical-align: top;
}
.icon-custom > svg {
  display: inline-block;
  margin: auto;
  fill: none;
}
.icon-mdi > svg {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
